import { Button, CustomHeader, Screen, Text, TextInput } from "components"
import React, { useCallback, useRef, useState } from "react"
import { FlatList, Image, TouchableOpacity, View, useWindowDimensions } from "react-native"
import { style } from "./styles"
import { useFocusEffect, useNavigation } from "@react-navigation/native"
import { translate } from "i18n"
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons"
import Feather from "@expo/vector-icons/Feather"
import { useStores } from "models"
import { useSessionExpired } from "utils/function"
import { observer } from "mobx-react-lite"
import flash from "config/flash"
import Modal from "react-native-modal"
import { colors } from "colors"
import LinearGradient from "react-native-linear-gradient"
import { ActivityIndicator } from "react-native-paper"
import useResponsiveWidth from "components/fitSize"
import { useColor } from "app/theme/getThemes"
import { VoucherContainer } from "components/VoucherContainerv2"
import moment from "moment"

export const RedeemScreen = observer(() => {
  const voucherIcon = require("assets/voucherRedeemed.png")
  const { companyTheme } = useColor()

  const navigation = useNavigation<any>()
  // const { width } = useWindowDimensions()

  const getResponsiveWidth = useResponsiveWidth()
  const { width } = getResponsiveWidth()

  const { userStore } = useStores()
  const { sessionExpired } = useSessionExpired()
  // const [point, setPoint] = useState(userStore?.totalPoint || 0)
  const [point, setPoint] = useState(0)
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)
  const [voucher, setVoucher] = useState([])
  const [hasRedeemed, setHasRedeemed] = useState(false)
  const [selectedVoucher, setSelectedVoucher] = useState("")
  const [isSearchVisible, setIsSearchVisible] = useState(false)
  const [searchText, setSearchText] = useState("")
  const [loading, setLoading] = useState(false)
  const searchTextRef = useRef()
  const today = moment()

  useFocusEffect(
    useCallback(() => {
      setLoading(true)
      getTierByUserId()
      getUserPoint()
      // getVoucher()
    }, []),
  )

  const onCloseModal = () => {
    setIsModalVisible(false)
    setHasRedeemed(false)
    setSelectedVoucher("")
  }

  const getTierByUserId = async () => {
    await fetch(`${process.env.API_URL}/api/tier/member/${userStore.id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()
          const tier = responseData.get_member_tier_info
          console.log("Tier ===>", responseData)
          getVoucher(responseData?.current_tier)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const getUserPoint = async () => {
    await fetch(`${process.env.API_URL}/api/client/pointbal`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()
          setPoint(responseData?.data)
          // setPoint(9000)
          userStore?.update({
            totalPoint: responseData?.data,
            // totalPoint: 9000,
          })
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const redeemVoucher = async () => {
    await fetch(`${process.env.API_URL}/api/voucher_list/redeem`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
      body: JSON.stringify({
        voucher_id: selectedVoucher,
        member_id: userStore?.id,
      }),
    })
      .then(async (res) => {
        const responseData = await res?.json()

        console.log(responseData)

        setSelectedVoucher("")
        if (res?.ok) {
          setHasRedeemed(true)
          getUserPoint()
        } else {
          onCloseModal()
          const errorMsg = await res?.json()
          if (errorMsg?.message === "Token expired" || errorMsg?.message === "Invalid token") {
            sessionExpired()
          } else if (errorMsg?.message === "Error redeem voucher. No stock is available.") {
            flash("error", translate("errors.outOfStock"))
          } else if (
            errorMsg?.message === "Error redeem voucher. Balance is not enough to redeem."
          ) {
            flash("error", translate("errors.notEnoughPoint"))
          } else {
            flash("error", translate("errors.failedToRedeem"))
          }
        }
      })
      .catch((e) => {
        onCloseModal()
        flash("error", translate("errors.failedToRedeem"))
        setSelectedVoucher("")
        console.error(e)
      })
  }

  const getVoucher = async (filterId) => {
    await fetch(`${process.env.API_URL}/api/voucher/type/redemption`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        setLoading(false)
        if (res?.ok) {
          const responseData = await res?.json()

          console.log(
            responseData.filter(
              (a) =>
                a.status === "active" && (a.member_tier_id === filterId || a.member_tier_id === 0),
            ),
          )

          setVoucher(
            sortVouchers(responseData.filter(
              (a) =>
                a.status === "active" &&
                a.voucher_type === "redemption" &&
                (a.member_tier_id === filterId || a.member_tier_id === 0),
            )),
          )
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          } else {
            flash("error", translate("errors.failedToRetreiveVoucher"))
          }
        }
      })
      .catch((e) => {
        setLoading(false)
        flash("error", translate("errors.failedToRetreiveVoucher"))
        console.error(e)
      })
  }

  const getVoucherStatus = (voucher) => {
    if (Number(voucher?.remaining_voucher || 0) <= 0) {
      return "Fully Redeemed"
    }
    if (voucher?.use_at) {
      return "Used"
    }
    if (moment(voucher?.voucher_expire_at).isBefore(moment())) {
      return "Expired"
    }
    if (voucher?.voucher_barcode) {
      return "Claimed"
    }
    if (moment(voucher?.start_date).isAfter(moment().subtract(7, "days"))) {
      return "New"
    }
    return "Unclaimed"
  }

  const sortVouchers = (vouchers) => {
    const ranking = {
      New: 1,
      Unclaimed: 2,
      Claimed: 3,
      Used: 4,
      Expired: 5,
      "Fully Redeemed": 6,
    }

    return vouchers.sort((a, b) => {
      const statusA = getVoucherStatus(a)
      const statusB = getVoucherStatus(b)
      return ranking[statusA] - ranking[statusB]
    })
  }

  return (
    <>
      <CustomHeader
        containerStyle={style.headerContainer}
        height={isSearchVisible ? 200 : 135}
        // headerTitle={translate("redeemScreen.title")}
        headerTitle={"Redemption"}
        headerRight={() => {
          return (
            <View style={style.headerLogoContainer}>
              <MaterialCommunityIcons
                name="ticket-confirmation-outline"
                size={30}
                color="white"
                onPress={() => navigation.navigate("voucher")}
              />
              <Feather
                onPress={() => {
                  setSearchText("")
                  setIsSearchVisible(!isSearchVisible)
                }}
                name="search"
                size={30}
                color="white"
              />
            </View>
          )
        }}
      >
        {isSearchVisible && (
          <LinearGradient
            colors={[companyTheme.first, companyTheme.second]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
          >
            <TextInput
              textFieldContainer={{ borderRadius: 10 }}
              textFieldStyle={{ height: 40 }}
              autoFocus
              textRef={searchTextRef}
              rightIcon={() => (
                <Feather
                  onPress={() => {
                    searchTextRef?.current && setSearchText(searchTextRef?.current?.value)
                  }}
                  name="search"
                  size={30}
                  color={companyTheme.first}
                />
              )}
              onSubmitEditing={(e) => {
                setSearchText(e?.nativeEvent?.text)
              }}
              placeholder={translate("redeemScreen.voucherName")}
            />
          </LinearGradient>
        )}
        <View style={style.pointContainer}>
          <Text style={style.text}>{translate("redeemScreen.availablePoint")}</Text>
          <Text style={style.text}>
            {point?.toLocaleString() || 0} {translate("redeemScreen.point")}
          </Text>
        </View>
      </CustomHeader>
      <Screen>
        <View style={style.container}>
          <FlatList
            data={
              searchText
                ? voucher?.filter((item) => item?.voucher_name.includes(searchText))
                : voucher
            }
            contentContainerStyle={style.flatListContainer}
            showsVerticalScrollIndicator={false}
            ListEmptyComponent={() => {
              return (
                <View style={style.emptyContainer}>
                  {loading ? (
                    <ActivityIndicator size="large" color={companyTheme.first} />
                  ) : (
                    <>
                      <Image
                        source={require("../../../../assets/empty-icon.png")}
                        style={{ width: 100, height: 100, resizeMode: "contain" }}
                      />
                      <Text style={style.emptyTitle}>{translate("redeemScreen.noVoucher")}</Text>
                      <Text>{translate("redeemScreen.stayTuned")}</Text>
                    </>
                  )}
                </View>
              )
            }}
            renderItem={({ item }) => {
              const regex = /<[^>]*>/gim
              const filteredDescriptionText = item?.voucher_description?.replace(regex, "")
              return (
                <View>
                  <VoucherContainer
                    v2
                    voucherDescription={filteredDescriptionText}
                    voucherImg={item?.voucher_image}
                    voucherName={item?.voucher_name}
                    voucherPointReq={item?.voucher_point_required}
                    voucherStartDate={item?.start_date}
                    isEmpty={Number(item?.remaining_voucher || 0) <= 0}
                    voucherExpiredDate={null}
                    isHistory={false}
                    isPromotion={false}
                    useAt={null}
                    button={() => {
                      return (
                        <Button
                          onPress={() => {
                            if (point < item?.voucher_point_required) {
                              flash("error", translate("errors.notEnoughPoint"))
                            } else {
                              setIsModalVisible(true)
                              setSelectedVoucher(item?.voucher_catalog_id)
                            }
                          }}
                          style={{ width: "90%", alignSelf: "center" }}
                          title="Redeem"
                        />
                      )
                    }}
                    onPress={() =>
                      navigation.navigate("voucherDetail", {
                        item,
                        routeFrom: "view",
                      })
                    }
                    currentLocation="redeem"
                  />
                </View>
              )
            }}
          />
        </View>
        <Modal
          isVisible={isModalVisible}
          onBackdropPress={() => onCloseModal()}
          onBackButtonPress={() => onCloseModal()}
        >
          <View style={style.modalContainer}>
            {!hasRedeemed ? (
              <>
                <Text>{translate("voucherDetailScreen.areYouSureRedeem")}</Text>
                <View style={style.redeemModalContainer}>
                  <Button
                    onPress={() => onCloseModal()}
                    title={translate("voucherDetailScreen.redeemLater")}
                    style={[style.redeemLaterButton, { borderColor: companyTheme.first }]}
                    titleStyle={{
                      color: companyTheme.first,
                    }}
                  />
                  <Button
                    onPress={() => redeemVoucher()}
                    title={translate("voucherDetailScreen.redeem")}
                    style={style.flex}
                  />
                </View>
              </>
            ) : (
              <View>
                <Image source={voucherIcon} style={style.modalImage} />
                <View style={style.modalTextContainer}>
                  <Text style={style.modalTitleText}>
                    {translate("voucherScreen.voucherRedeemed")}
                  </Text>
                  <Text style={style.modalDescriptionText}>
                    {translate("voucherScreen.findVoucher")}
                  </Text>
                  <Button
                    title={translate("voucherScreen.checkVoucher")}
                    onPress={() => {
                      onCloseModal()
                      navigation.navigate("voucher")
                    }}
                  />
                </View>
              </View>
            )}
          </View>
        </Modal>

        {/* <Modal
          isVisible={rewardModal}
          onBackdropPress={() => onCloseModal()}
          onBackButtonPress={() => onCloseModal()}
        >
          <View style={style.modalContainer}>
            <View style={[style.ml20, { width: "70%" }]}>
              {reward.map((item, index) => (
                <View key={index}>
                  <Text style={style.tierSpendText}>{item?.rewardTitle}</Text>
                  <View style={{ flexDirection: "row", flexWrap: "wrap", marginVertical: 10 }}>
                    {Array.from({ length: item.totalRewards })
                      .reduce((rows, _, i) => {
                        if (i % 5 === 0) rows.push([])
                        rows[rows.length - 1].push(i)
                        return rows
                      }, [])
                      .map((row, rowIndex) => (
                        <View key={rowIndex} style={{ flexDirection: "row", marginBottom: 10 }}>
                          {row.map((index) => (
                            <View
                              key={index}
                              style={{
                                backgroundColor: "#D3D3D3",
                                width: 30,
                                height: 30,
                                marginRight: 10,
                                borderRadius: 15,
                                alignItems: "center",
                                justifyContent: "center",
                                borderWidth: 1,
                                borderColor: index < item.receivedReward ? "#FFD700" : "black",
                                borderStyle: "dashed",
                                position: "relative",
                              }}
                            >
                              {index < item.receivedReward ? (
                                <LinearGradient
                                  colors={["#FFFACD", "#FFD700", "#FFC107"]}
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    borderRadius: 15,
                                  }}
                                />
                              ) : (
                                <View
                                  style={{
                                    backgroundColor: "#fefef4",
                                    position: "absolute",
                                    borderRadius: 15,
                                  }}
                                />
                              )}
                              <Text
                                style={[
                                  style.tierSpendText,
                                  { color: "#000", zIndex: 998, marginTop: 0 },
                                ]}
                              >
                                {index + 1}
                              </Text>
                              {index < item.receivedReward && (
                                <>
                                  <MaterialCommunityIcons
                                    name="star-four-points"
                                    size={8}
                                    color="#FFFFE0"
                                    style={{ position: "absolute", top: 3, left: 3 }}
                                  />
                                  <MaterialCommunityIcons
                                    name="star-four-points"
                                    size={6}
                                    color="#FFFACD"
                                    style={{ position: "absolute", bottom: 5, right: 5 }}
                                  />
                                </>
                              )}
                            </View>
                          ))}
                        </View>
                      ))}
                  </View>
                  <Text style={[style.tierSpendText, { flex: 1 }]}>{item?.rewards}</Text>
                  {item?.receivedReward === item?.totalRewards && (
                    <Button
                      style={[
                        style.mt10,
                        {
                          paddingTop: "3%",
                          backgroundColor: "white",
                          color: "red",
                        },
                      ]}
                      title="Redeem"
                    />
                  )}
                </View>
              ))}
            </View>
          </View>
        </Modal> */}
      </Screen>
    </>
  )
})
